import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const brokeredLoadGetNextDocumentNumberAtom = createMutationAtomFactory(
  'brokerage.brokeredLoadGetNextDocumentNumber',
  () => ({
    tradeLoadNextDocumentNumber: true,
  }),
);
